// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"327":"e6875463","975":"component---src-templates-default-tsx"}[chunkId] || chunkId) + "-" + {"327":"d1a6910394a0a1bdb3fb","419":"69101b1b54d450f6b162","975":"16cf5d2a9253305e65dc"}[chunkId] + ".js";
};